import {$clientApi} from "../http";
import {IGymDetails, IGymSettings} from "../models/GymSettings";

class GymSettingsServiceClass {

   async getGymSettings() {
        return $clientApi.get<IGymSettings>(`api/public/gym-settings`);
   }

   async getGymLocation() {
       return await $clientApi.get<{data: IGymDetails, success: boolean}>(`api/gym/gym-details`);
   }

}

export const GymSettingsService = new GymSettingsServiceClass();